import React from 'react';

function TableData({ etapas }) {
  return (
    <>
      {etapas.EtapasAbeturas.map((etapa) => {
        switch (true) {
          case etapa.mapeamento_status !== 'CONCLUIDO':
            return <p>Mapeamento</p>;
          case etapa.minuta_status !== 'CONCLUIDO':
            return <p>Elaboração Minuta Contratual</p>;
          case etapa.viabilidade_status !== 'CONCLUIDO':
            return <p>Viabilidade</p>;
          case etapa.dbe_status !== 'CONCLUIDO':
            return <p>DBE</p>;
          case etapa.certificado_status !== 'CONCLUIDO':
            return <p>Certificado Bird ID</p>;
          case etapa.registro_status !== 'CONCLUIDO':
            return <p>Registro</p>;
          case etapa.inscricao_municipal_status !== 'CONCLUIDO':
            return <p>Inscrição Municipal</p>;
          case etapa.deferimento_simples_status !== 'CONCLUIDO':
            return <p>Deferimento Simples Nacional</p>;
          case etapa.licenciamento_status !== 'CONCLUIDO':
            return <p>Licenciamento</p>;
          case etapa.mapeamento_status &&
            etapa.minuta_status &&
            etapa.viabilidade_status &&
            etapa.dbe_status &&
            etapa.certificado_status &&
            etapa.registro_status &&
            etapa.inscricao_municipal_status &&
            etapa.deferimento_simples_status &&
            etapa.licenciamento_status === 'CONCLUIDO':
            return <p>Concluído</p>;
          default:
            return <p>Não iniciado</p>;
        }
      })}
    </>
  );
}

export default TableData;
